import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInSeconds from 'date-fns/differenceInSeconds';

import { quizAnswer, quizNext, quizEnd } from '../state/quiz/actions';

import clockUrl from '../icons/clock.png';

function getTime(currentDate, endDate) {
  let minutes = differenceInMinutes(endDate, currentDate);
  let seconds = differenceInSeconds(endDate, currentDate);

  if (minutes < 0) {
    minutes = 0;
  }

  if (seconds < 0) {
    seconds = 0;
  }

  return `${minutes.toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
}

const Timer = ({ endTime, endQuiz }) => {
  const [time, setTime] = useState(getTime(new Date(), endTime));

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const currentTime = new Date();
      const secondsToEnd = differenceInSeconds(endTime, currentTime);

      if (secondsToEnd > 0) {
        setTime(getTime(currentTime, endTime));
      } else {
        endQuiz();
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  });

  return (
    <div className="timer">
      <img className="timer__icon" src={clockUrl} />
      <div className="timer__text">
        Pozostało: <br />
        {time} min
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    endTime: state.root.quiz.endTime,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    endQuiz: () => dispatch(quizEnd()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timer);
